import component from './TwitchPost';
import handles from './handles';

export default {
  component,
  handles,
};



// WEBPACK FOOTER //
// ./src/components/TwitchPost/index.js